export const SHOW_CONFIRM_MODAL = 'SHOW_CONFIRM_MODAL';
export const SHOW_SUCCESS_MODAL = 'SHOW_SUCCESS_MODAL';
export const CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE';
export const HIDE_MODAL = 'HIDE_MODAL';
